import { cn } from '@/shadcn-ui/utils';
import { unwrapFragments } from '../utils/unwrap-fragments';
import React from 'react';

interface IconContentGridProps {
  children: React.ReactNode;
  gridClassName?: string;
  /** Width of the first column in pixels */
  iconColumnWidth?: number;
  iconColumnClassName?: string;
  contentColumnClassName?: string;
}

export default function IconContentGrid({
  gridClassName,
  iconColumnWidth = 32,
  iconColumnClassName,
  contentColumnClassName,
  children,
}: IconContentGridProps) {
  const unwrappedChildren = unwrapFragments(children);

  return (
    <div
      className={cn('grid w-full grid-cols-2 gap-2', gridClassName)}
      style={{
        gridTemplateColumns: `${iconColumnWidth}px 1fr`,
      }}
    >
      {React.Children.toArray(unwrappedChildren).map((child, i) => {
        // First column
        if (i % 2 === 0) {
          return (
            <div
              key={i}
              className={cn(
                'flex justify-center self-start justify-self-center',
                iconColumnClassName
              )}
            >
              {child}
            </div>
          );
        }

        // Second column
        return (
          <div
            key={i}
            className={cn(
              'flex justify-center self-start justify-self-start',
              contentColumnClassName
            )}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
}
